import React, { useState, useMemo } from 'react'

// create context
export const SidebarContext = React.createContext()

export const SidebarProvider = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false)
  const [isCollapsed, setIsCollapsed] = useState(false)

  function toggleSidebar() {
    setIsSidebarOpen(!isSidebarOpen)
  }

  function closeSidebar() {
    setIsSidebarOpen(false)
  }

  function collapseSidebar() {
    setIsCollapsed(true)
  }

  function expandSidebar() {
    setIsCollapsed(false)
  }

  function toggleCollapsed() {
    setIsCollapsed((prev) => !prev)
  }

  const value = useMemo(
    () => ({
      isSidebarOpen,
      toggleSidebar,
      closeSidebar,
      isCollapsed,
      collapseSidebar,
      expandSidebar,
      toggleCollapsed,
    }),
    [isSidebarOpen, isCollapsed]
  )

  return <SidebarContext.Provider value={value}>{children}</SidebarContext.Provider>
}
